import { get } from '../util/request';

async function fetchVideoResponsePath(responseId) {
  const url = `/a/api/videoResponsePath/${responseId}`;
  return get(url)().then(res => res.body && res.body.payload && { responseId, url: res.body.payload });
}

export { fetchVideoResponsePath };
